import axiosInstance from "../config/axios.config";

export const generateDischargeSummaryApi = (id, params) => {
  return axiosInstance.get(
    `/inpatient/discharge-summary/${id}/?practitioner=${params}`
  );
};
export const getDischargeSummaryApi = (id, params) => {
  return axiosInstance.get(
    `inpatient/get-discharge-summary/${id}/?practitioner=${params}`
  );
};
export const submitDischargeSummaryApi = (id, params, payload) => {
  return axiosInstance.put(
    `inpatient/get-discharge-summary/${id}/?practitioner=${params}`,
    payload
  );
};
export const getEmrDownloadApi = (id, params) => {
  return axiosInstance.get(`inpatient/emr-download/${id}/?${params}`);
};
export const downloadEmrApi = (id, params) => {
  return axiosInstance.get(`inpatient/emr-download/${id}/?${params}`);
};
/**
 * Multi-recipient, multi-channel discharge summary share.
 *
 *   POST inpatient/share-discharge-summary-multi/<admission_id>/
 *   { practitioner, email: [{ name, email }], whatsapp: [{ name, whatsapp }] }
 *
 * Returns { message, results: { email: [...], whatsapp: [...] } } with a
 * per-recipient status, so partial failures can be reported individually.
 */
export const shareDischargeSummaryMultiApi = (admissionId, payload) => {
  return axiosInstance.post(
    `inpatient/share-discharge-summary-multi/${admissionId}/`,
    payload
  );
};

export const shareDischargeSummaryApi = (id, payload) => {
  return axiosInstance.post(
    `inpatient/share-discharge-summary/${id}/`,
    payload
  );
};
